import { ISearchSuggestionProps } from '@1js/search-types';
import { NgZone } from '@angular/core';
import React from 'react';
import { OfficeRoute } from '../../shared/constants/office-route.enum';
import { OfficeRouteService } from '../../shared/services/office-route.service';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SearchSuggestionCompoundButtonComponent } from './search-suggestion-components/search-suggestion-compoundButton.component';

interface SerpSearchProps extends ISearchSuggestionProps {
    readonly isDarkMode: boolean;
    readonly isPwa: boolean;
    readonly ngZone: NgZone;
    readonly officeRouteService: OfficeRouteService;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly searchText: string;
    readonly title: string;
}

export class SerpSearchSuggestionComponent extends React.Component<SerpSearchProps> {

    public readonly handleClick = () => (e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault();
        this.props.searchInstrumentationService.logSearchClickEvent(
            SearchResultType.Serp,
            SearchResultElementId.Serp,
            true,
            SearchResultType.SeeMore /* See more result in Serp provider*/);
        this.props.ngZone.run(() => this.props.officeRouteService.navigateTo(
            { route: OfficeRoute.ConsumerAllSearch },
            false,
            { q: this.props.searchText }
        ));
    }

    public render() {
        return (
            <SearchSuggestionCompoundButtonComponent
                title={this.props.title}
                handleClick={this.handleClick()}
                hideIcon={true}
                description=''
                style={this.props.isDarkMode && this.props.isPwa
                        ? 'serp-search-suggestion-text search-compound-button-container--see-more--darkMode ohpAppTheme ms-fcl-tda'
                        : 'serp-search-suggestion-text search-compound-button-container--see-more ohpAppTheme ms-fcl-tda'}
                target='_blank'
                isDarkMode={this.props.isDarkMode}
                isPwa={this.props.isPwa}
                useThemeColor={true}
            />
        );
    }
}
